import type { ICoupon } from './types'

export function getPrice(basePrice: number, coupon: ICoupon) {
  return basePrice - getDiscountAmount(basePrice, coupon)
}

export function getDiscountAmount(basePrice: number, coupon: ICoupon) {
  switch (coupon.discount.type) {
    case 'percent':
      return (basePrice * coupon.discount.value) / 100
    case 'absolute':
      return coupon.discount.value
    default:
      return 0
  }
}
